import './Worksite.scss';

import cn from 'classnames';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import Button from '@/common/components/atoms/Button/Button';
import ButtonClose from '@/common/components/molecules/ButtonClose/ButtonClose';
import { ITEM_TYPES } from '@/common/constants';
import { ReactComponent as EditIcon } from '@/materiaux/assets/icons/edit.svg';

import useWorksite from './useWorksite';
import { WorksiteDefaultProps, WorksitePropTypes } from './Worksite.proptypes';

const Worksite = ({
  className,
  disabled,
  entity,
  isLoading,
  onSuccess,
  type,
}) => {
  const { t } = useTranslation();

  const {
    getWorksiteLabel,
    isDisabled,
    onOpenWorksiteModal,
    onUpdateEntity,
  } = useWorksite({
    disabled,
    entity,
    isLoading,
    onSuccess,
    type,
  });

  /**
   * Render by type
   */
  const getRenderByType = useMemo(() => {
    if (entity.worksite) {
      switch (type) {
        case ITEM_TYPES.quote:
          return <></>;
        case ITEM_TYPES.order:
          return (
            <>
              <ButtonClose
                className="worksite__remove"
                context="worksite-remove"
                disabled={isDisabled.disabled}
                onClick={() => onUpdateEntity({ worksiteCode: '' })}
              />
              <span className="worksite__label">{getWorksiteLabel}</span>
              <Button
                className="worksite__edit"
                context="worksite-edit"
                disabled={isDisabled.disabled}
                onClick={onOpenWorksiteModal}
              >
                <EditIcon className="icon" />
              </Button>
            </>
          );
        case ITEM_TYPES.installer:
        case ITEM_TYPES.cart:
        default:
          return (
            <>
              <Button
                className="worksite__label"
                context="worksite" // TODO: to check
                disabled={isDisabled.disabled}
                onClick={onOpenWorksiteModal}
                variant="simple-text"
              >
                {entity.worksite.label}
              </Button>
              <ButtonClose
                className="worksite__remove"
                context="worksite-remove"
                disabled={isDisabled.worksiteRequired}
                onClick={() => onUpdateEntity({ worksiteCode: '' })}
              />
            </>
          );
      }
    }

    switch (type) {
      case ITEM_TYPES.order:
        return <></>;
      case ITEM_TYPES.cart:
      case ITEM_TYPES.installer:
      case ITEM_TYPES.quote:
      default:
        return (
          <Button
            className="button--add-modal"
            context="worksite-add"
            disabled={isDisabled.disabled}
            onClick={onOpenWorksiteModal}
            variant="small-light"
          >
            {t('ebat:entities:common.aside.select_worksite')}
          </Button>
        );
    }
  }, [
    entity,
    getWorksiteLabel,
    isDisabled,
    onOpenWorksiteModal,
    onUpdateEntity,
    t,
    type,
  ]);

  return (
    <div className={cn('worksite', className)} data-qa-id="worksite-selector">
      {getRenderByType}
    </div>
  );
};

Worksite.defaultProps = {
  ...WorksiteDefaultProps,
};

Worksite.propTypes = {
  ...WorksitePropTypes,
};

export default Worksite;
